"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Plus = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var Plus = function Plus(props) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({
    transform: "rotate(0)"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.711 11.287l.005-5.344c0-.396-.32-.717-.716-.717-.396 0-.717.321-.717.717l.005 5.344-5.344-.005c-.396 0-.717.321-.717.717 0 .396.32.717.717.717l5.344-.005-.005 5.344c0 .19.074.373.209.507.135.135.317.21.508.21.19 0 .373-.075.507-.21.135-.134.21-.317.21-.507l-.006-5.344 5.344.005c.19 0 .373-.075.508-.21.135-.134.21-.317.21-.507s-.075-.373-.21-.508c-.135-.134-.317-.21-.508-.209l-5.344.005z"
  }));
};

exports.Plus = Plus;